export const agreements = {
  agreement: {
    title: '用户服务协议',
    content: '用户服务协议'
  }
};

// 委托代收 缓存key，防止多次点击，后端没有拦截，前端处理下
export const ENTRUST_KEY = 'ENTRUST_KEY_';
